function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { createRef, useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import styles from "./MembershipPlan.module.scss";
import { Text } from "../../Text/Text/Text";
import { Button } from "../../Button/Button/Button";
import { Popup } from "../../Popup/Popup/Popup";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MembershipPlan = function MembershipPlan(_ref) {
  var _ref$bestValueText = _ref.bestValueText,
    bestValueText = _ref$bestValueText === void 0 ? '' : _ref$bestValueText,
    _ref$plans = _ref.plans,
    plans = _ref$plans === void 0 ? [] : _ref$plans;
  var promoPopup = useRef([]);
  var offerTermsPopup = useRef([]);
  var elementsRef = useRef([]);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    keyIdx = _useState2[0],
    setKeyIdx = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedItem = _useState4[0],
    setSelectedItem = _useState4[1];
  var popupClick = function popupClick(refPopup) {
    var _refPopup$current;
    refPopup === null || refPopup === void 0 ? void 0 : (_refPopup$current = refPopup.current) === null || _refPopup$current === void 0 ? void 0 : _refPopup$current.togglePopup();
  };
  useEffect(function () {
    if (plans && plans.length > 0) {
      promoPopup.current = plans.map(function () {
        return /*#__PURE__*/createRef();
      });
      offerTermsPopup.current = plans.map(function () {
        return /*#__PURE__*/createRef();
      }) || [];
      var elementsRefs = plans.map(function (plan) {
        var _plan$priceDetails;
        return (_plan$priceDetails = plan.priceDetails) === null || _plan$priceDetails === void 0 ? void 0 : _plan$priceDetails.map(function () {
          return /*#__PURE__*/createRef();
        });
      });
      elementsRef.current = elementsRefs;
      setKeyIdx(1);
    }
  }, [plans]);
  var changeSelectedItem = function changeSelectedItem(idx) {
    setSelectedItem(idx);
  };
  var buildPriceItem = function buildPriceItem(price, index, planIndex) {
    var _elementsRef$current$;
    return /*#__PURE__*/_jsxs("div", {
      className: styles.priceDetailItem,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.labelDetailsWrapper,
        children: [/*#__PURE__*/_jsxs("div", {
          style: {
            maxWidth: price === null || price === void 0 ? void 0 : price.priceLabelMaxWidth
          },
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.priceLabelMainItem,
            children: price === null || price === void 0 ? void 0 : price.label
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.priceLabelItem,
            children: [(price === null || price === void 0 ? void 0 : price.label2) && /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx("span", {
                children: price === null || price === void 0 ? void 0 : price.label2
              })
            }), (price === null || price === void 0 ? void 0 : price.label3) && /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx("span", {
                children: price === null || price === void 0 ? void 0 : price.label3
              })
            })]
          })]
        }), (price === null || price === void 0 ? void 0 : price.detailsInfo) && /*#__PURE__*/_jsx("div", {
          className: styles.labelInfoWrapper,
          children: /*#__PURE__*/_jsx(Popup, {
            ref: elementsRef === null || elementsRef === void 0 ? void 0 : (_elementsRef$current$ = elementsRef.current[planIndex]) === null || _elementsRef$current$ === void 0 ? void 0 : _elementsRef$current$[index],
            handle: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
              onClick: function onClick() {
                var _elementsRef$current$2;
                return popupClick(elementsRef === null || elementsRef === void 0 ? void 0 : (_elementsRef$current$2 = elementsRef.current[planIndex]) === null || _elementsRef$current$2 === void 0 ? void 0 : _elementsRef$current$2[index]);
              },
              type: "no-style",
              className: styles.detailsInfoButton,
              "aria-haspopup": "dialog"
            }, price.detailsInfoAttributes), {}, {
              accessibilityLabel: "info-button",
              children: /*#__PURE__*/_jsx("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 16 16",
                children: /*#__PURE__*/_jsxs("g", {
                  children: [/*#__PURE__*/_jsx("path", {
                    d: "M8 2a6 6 0 1 0 6 6 6 6 0 0 0-6-6Zm0 11a5 5 0 1 1 5-5 5 5 0 0 1-5 5Z"
                  }), /*#__PURE__*/_jsx("path", {
                    d: "M8 6.85a.5.5 0 0 0-.5.5v3.4a.5.5 0 0 0 1 0v-3.4a.5.5 0 0 0-.5-.5zM8 4.8a.53.53 0 0 0-.51.52v.08a.47.47 0 0 0 .51.47.52.52 0 0 0 .5-.5v-.12A.45.45 0 0 0 8 4.8z"
                  })]
                })
              })
            })),
            clickOutsideDeactivates: true,
            children: /*#__PURE__*/_jsx(Text, {
              typog: "captionSmall",
              richText: true,
              children: price.detailsInfo
            })
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.priceItem,
        children: [(price === null || price === void 0 ? void 0 : price.price) && /*#__PURE__*/_jsx("span", {
          className: styles.priceItem1,
          children: price === null || price === void 0 ? void 0 : price.price
        }), (price === null || price === void 0 ? void 0 : price.newPrice) && /*#__PURE__*/_jsx("span", {
          children: price === null || price === void 0 ? void 0 : price.newPrice
        })]
      })]
    }, "priceItem_".concat(index));
  };
  var buildPriceTag = function buildPriceTag(plan) {
    var _plan$button, _plan$button2, _plan$button3, _plan$button4;
    var isActive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var isBestValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return plan && /*#__PURE__*/_jsxs("div", {
      className: styles.price,
      children: [bestValueText && isBestValue && selectedItem !== 0 && /*#__PURE__*/_jsx("div", {
        className: classnames(styles.bestValueTag, styles.bestValueTagOther),
        children: bestValueText
      }), /*#__PURE__*/_jsxs("div", {
        className: classnames(styles.priceText, {
          [styles.pricetextOther]: !isActive
        }),
        children: [/*#__PURE__*/_jsx("span", {
          children: plan === null || plan === void 0 ? void 0 : plan.price
        }), /*#__PURE__*/_jsx("span", {
          style: {
            maxWidth: plan === null || plan === void 0 ? void 0 : plan.priceTextMaxWidth
          },
          children: plan === null || plan === void 0 ? void 0 : plan.priceText
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.priceButton,
        children: isActive ? /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
          className: classnames(styles.button),
          url: plan === null || plan === void 0 ? void 0 : (_plan$button = plan.button) === null || _plan$button === void 0 ? void 0 : _plan$button.url
        }, plan === null || plan === void 0 ? void 0 : (_plan$button2 = plan.button) === null || _plan$button2 === void 0 ? void 0 : _plan$button2.attributes), {}, {
          children: plan === null || plan === void 0 ? void 0 : (_plan$button3 = plan.button) === null || _plan$button3 === void 0 ? void 0 : _plan$button3.text
        })) : /*#__PURE__*/_jsx("button", {
          className: classnames(styles.button, styles.buttonOther),
          children: plan === null || plan === void 0 ? void 0 : (_plan$button4 = plan.button) === null || _plan$button4 === void 0 ? void 0 : _plan$button4.secondaryText
        })
      })]
    });
  };
  var isActivePanel = function isActivePanel(idx) {
    return selectedItem === idx;
  };
  var buildMembershipPlan = function buildMembershipPlan(plan, idx) {
    var _promoPopup$current, _offerTermsPopup$curr;
    return /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: classnames(styles.accordion, styles.otherOffers, {
          [styles.accordionActive]: isActivePanel(idx)
        }),
        onClick: function onClick() {
          return changeSelectedItem(idx);
        },
        children: buildPriceTag(plan, false, idx === 0)
      }), /*#__PURE__*/_jsxs("div", {
        className: classnames(styles.panel, {
          [styles.panelActive]: isActivePanel(idx)
        }),
        children: [bestValueText && idx === 0 && selectedItem === 0 && /*#__PURE__*/_jsx("div", {
          className: styles.bestValueTag,
          children: bestValueText
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.memberPlan,
          children: [buildPriceTag(plan, true), /*#__PURE__*/_jsxs("div", {
            className: styles.promo,
            children: [/*#__PURE__*/_jsx(Text, {
              className: styles.promoText,
              richText: true,
              typog: "bodycopySmall",
              children: plan.promoText
            }), plan.promoInfoText && /*#__PURE__*/_jsx(Popup, {
              ref: promoPopup === null || promoPopup === void 0 ? void 0 : (_promoPopup$current = promoPopup.current) === null || _promoPopup$current === void 0 ? void 0 : _promoPopup$current[idx],
              handle: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
                onClick: function onClick() {
                  var _promoPopup$current2;
                  return popupClick(promoPopup === null || promoPopup === void 0 ? void 0 : (_promoPopup$current2 = promoPopup.current) === null || _promoPopup$current2 === void 0 ? void 0 : _promoPopup$current2[idx]);
                },
                className: styles.promoIconButton,
                type: "no-style",
                "aria-haspopup": "dialog",
                accessibilityLabel: "info-icons"
              }, plan.promoAttributes), {}, {
                children: /*#__PURE__*/_jsx("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  className: styles.promoIcon,
                  viewBox: "0 0 416.98 416.98",
                  children: /*#__PURE__*/_jsx("g", {
                    children: /*#__PURE__*/_jsx("g", {
                      children: /*#__PURE__*/_jsx("path", {
                        d: "M356.004,61.156c-81.37-81.47-213.377-81.551-294.848-0.182c-81.47,81.371-81.552,213.379-0.181,294.85 c81.369,81.47,213.378,81.551,294.849,0.181C437.293,274.636,437.375,142.626,356.004,61.156z M237.6,340.786 c0,3.217-2.607,5.822-5.822,5.822h-46.576c-3.215,0-5.822-2.605-5.822-5.822V167.885c0-3.217,2.607-5.822,5.822-5.822h46.576 c3.215,0,5.822,2.604,5.822,5.822V340.786z M208.49,137.901c-18.618,0-33.766-15.146-33.766-33.765 c0-18.617,15.147-33.766,33.766-33.766c18.619,0,33.766,15.148,33.766,33.766C242.256,122.755,227.107,137.901,208.49,137.901z"
                      })
                    })
                  })
                })
              })),
              clickOutsideDeactivates: true,
              children: /*#__PURE__*/_jsx(Text, {
                typog: "captionSmall",
                richText: true,
                children: plan.promoInfoText
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.priceWrapper,
            children: [plan.priceDetails && /*#__PURE__*/_jsx("div", {
              className: styles.priceDetail,
              children: plan.priceDetails.map(function (price, index) {
                return buildPriceItem(price, index, idx);
              })
            }), plan.priceTotal && /*#__PURE__*/_jsx("div", {
              className: styles.priceTotal,
              children: buildPriceItem(plan.priceTotal, 99, idx)
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.asterisk,
              children: [plan.asteriskText, ' ', plan.offerTerms && /*#__PURE__*/_jsx(Popup, {
                ref: offerTermsPopup === null || offerTermsPopup === void 0 ? void 0 : (_offerTermsPopup$curr = offerTermsPopup.current) === null || _offerTermsPopup$curr === void 0 ? void 0 : _offerTermsPopup$curr[idx],
                handle: /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
                  onClick: function onClick() {
                    var _offerTermsPopup$curr2;
                    return popupClick(offerTermsPopup === null || offerTermsPopup === void 0 ? void 0 : (_offerTermsPopup$curr2 = offerTermsPopup.current) === null || _offerTermsPopup$curr2 === void 0 ? void 0 : _offerTermsPopup$curr2[idx]);
                  },
                  type: "no-style",
                  "aria-haspopup": "dialog",
                  className: styles.offerTerms
                }, plan.offerTermsAttribute), {}, {
                  children: plan.offerTermsText
                })),
                clickOutsideDeactivates: true,
                children: /*#__PURE__*/_jsx(Text, {
                  typog: "captionSmall",
                  richText: true,
                  children: plan.offerTerms
                })
              })]
            })]
          })]
        })]
      })]
    }, "plan_".concat(idx));
  };
  return /*#__PURE__*/_jsx("div", {
    className: styles.membershipPlan,
    children: /*#__PURE__*/_jsx("div", {
      className: classnames({
        [styles.accordionWrapper]: selectedItem !== 0
      }),
      children: plans && plans.map(function (plan, idx) {
        return buildMembershipPlan(plan, idx);
      })
    })
  }, "plans_".concat(keyIdx));
};